module.exports = __webpack_public_path__ + "img/paused_icon.163d1960.svg";